import { addTipsApi } from "@/api/take-order/take-order";
import { setOrderData, setOrderTotalPrice, setTipData } from "@/redux/slice/take-order-slice/order-slice";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";


function Tips({ setTipsPage }) {
    const [tipType, setTipType] = useState("percentage");
    const [amount, setAmount] = useState("0");
    const { orderData } = useSelector((state) => state.takeOrder.order);
    const dispatch = useDispatch();
    const percentages = ["2", "5", "10", "15", "20", "30"];


    const handleConfirm = () => {
        if (!amount) {
            toast.error("Please enter a tips amount.");
            return;
        }
        addTipsApi(orderData.id, {tip_type:tipType, tips:amount}).then((res) => {
            if (res.status === "success") {
                console.log("Tips added:", res.data);
                const updatedOrder = res.data?.order || res.data || res.order || res;
                if (updatedOrder && typeof updatedOrder === "object") {
                    dispatch(setOrderData({
                        ...orderData,
                        ...updatedOrder,
                    }));
                }
                if (res.data?.total_price !== undefined) {
                    dispatch(setOrderTotalPrice(res.data.total_price));
                }
                dispatch(setTipData({
                    tips_amount: res.data?.tips_amount ?? res.data?.total_tips_amount,
                    total_tips_amount: res.data?.total_tips_amount ?? res.data?.tips_amount,
                    tips: res.data?.tips ?? amount,
                    tip_type: res.data?.tip_type ?? tipType,
                    tips_mode: res.data?.tips_mode,
                    tips_breakdown: res.data?.tips_breakdown,
                }));
                toast.success("Tips added successfully!");
                setTipsPage(false);
            } else {
                toast.error(res.message || "Failed to add tips. Please try again.");
            }
        });
    }

    useEffect(() => {
        console.log("Current order data:", orderData);
        if (orderData?.tips !== undefined && orderData?.tips !== null) {
            setAmount(String(orderData.tips));
        } else {
            setAmount("0");
        }
        setTipType(orderData?.tip_type || "percentage");
    }, [orderData]);

    return (
        <div className="w-[500px] bg-color2 p-6 rounded-md border-2 border-color3 shadow-2xl text-white flex flex-col gap-5">
            <h2 className="text-xl font-semibold text-center mb-2">Tips / Gratuity</h2>

            {/* Toggle Tabs */}
            <div className="flex gap-4 w-full">
                <button 
                    onClick={() => setTipType("percentage")}
                    className={`flex-1 py-3 rounded-md font-medium transition-colors ${
                        tipType === "percentage" 
                        ? "bg-yellow-500 text-black" 
                        : " bg-color3 text-white hover:bg-gray-500"
                    }`}
                >
                    Percentage
                </button>
                <button 
                    onClick={() => setTipType("fixed")}
                    className={`flex-1 py-3 rounded-md font-medium transition-colors ${
                        tipType === "fixed" 
                        ? "bg-yellow-500 text-black" 
                        : " bg-color3 text-white hover:bg-gray-500"
                    }`}
                >
                    Fixed Amount
                </button>
            </div>

            {/* Input Field */}
            <div className="flex flex-col gap-2">
                <label className="text-sm font-medium">Tips Amount</label>
                <input 
                    type="text" 
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter tips amount" 
                    className="w-full p-3 bg-color3 border border-gray-600 rounded-md outline-none focus:border-gray-400 placeholder-gray-500" 
                />
            </div>

            {/* Quick Select Grid */}
            <div className="grid grid-cols-3 gap-4">
                {percentages.map((p) => (
                    <button 
                        key={p}
                        onClick={() => setAmount(p)}
                        className=" bg-color3 hover:bg-gray-500 text-white py-6 rounded-md font-bold text-lg transition-colors"
                    >
                        {p}
                    </button>
                ))}
            </div>

            {/* Footer Actions */}
            <div className="flex gap-4 mt-4">
                <button 
                    onClick={() => setTipsPage(false)} 
                    className="flex-1 bg-red-500 hover:bg-red-600 text-white py-3 rounded-md font-medium transition-colors"
                >
                    Close
                </button>
                <button 
                    onClick={handleConfirm}
                    className="flex-1 bg-green-500 hover:bg-green-600 text-white py-3 rounded-md font-medium transition-colors"
                >
                Confirm
                </button>
            </div>
        </div>
    );
}

export default Tips;